import { Box } from "@mui/material";
import StartPageBackground from "../../assets/start-page-background.png";
import AddressForm from "./AddressForm";
import { useGeoMap } from "../../context/GeoMapContext";
import { useEffect } from "react";

export const Home = () => {
  const { customerScopeRef } = useGeoMap();

  useEffect(() => {
    customerScopeRef.current = undefined;
  }, [customerScopeRef])
  
  return (
    <Box
      display="flex"
      flex={1}
      justifyContent="center"
      alignItems="flex-start"
      sx={{
        padding: { xs: '16px', sm: '50px' },
        backgroundImage: `url(${StartPageBackground})`,
        backgroundSize: 'cover',
        overflowY: 'auto',
      }}
    >
      <AddressForm />
    </Box>
  );
};

export default Home;
